import React, {useEffect, useRef} from 'react';
import Header from "../Header/Header";
import { Layout } from "../Layout/Layout";
import { Editor } from '@tinymce/tinymce-react';
import { useFormik } from 'formik';
import * as yup from 'yup';
import Swal from 'sweetalert2';
import axios from 'axios';
import { Link, useNavigate, useParams } from 'react-router-dom';

const validationSchema = yup.object({
    name: yup.string('Enter the template name').required('Template Name is required'),
    saEmailSubjectForSubject: yup.string('Enter the email subject').required('Email Subject is required'),
    saEmailBodyForSubject: yup.string('Enter the email body').required('Email Body is required'),
    reminderEmailSubjectForSubject: yup.string('Enter the email subject').required('Email Subject is required'),
    reminderEmailBodyForSubject: yup.string('Enter the email body').required('Email Body is required'),
    saEmailSubjectForRater: yup.string('Enter the email subject').required('Email Subject is required'),
    saEmailBodyForRater: yup.string('Enter the email body').required('Email Body is required'),
    reminderEmailSubjectForRater: yup.string('Enter the email subject').required('Email Subject is required'),
    reminderEmailBodyForRater: yup.string('Enter the email body').required('Email Body is required'),
});

export default function ViewEmailTemplate() {
    const navigate = useNavigate();
    const { templateId } = useParams();
    const editorSASubjectRef = useRef(null);
    const editorReminderSubjectRef = useRef(null);
    const editorSARaterRef = useRef(null);
    const editorReminderRaterRef = useRef(null);

    useEffect(() => {
        if(templateId > 0){
            axios.get(`api/email_template?id=${templateId}`).then(res => {
                if(res.data.success){
                    formik.setValues(res.data.data)
                }
            })
        }
        else{
            formik.resetForm();
        }
    }, [templateId])

    const initialValues = {
        id: templateId,
        name: '',
        saEmailSubjectForSubject: '',
        saEmailBodyForSubject: '',
        reminderEmailSubjectForSubject: '',
        reminderEmailBodyForSubject: '',
        saEmailSubjectForRater: '',
        saEmailBodyForRater: '',
        reminderEmailSubjectForRater: '',
        reminderEmailBodyForRater: '',
    }

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: validationSchema,
        onSubmit: values => {
            // handleSubmit(values);
        }
    });

    return(
        <Layout>
            <Header pageTitle="Add Email Template" />
            <div className="container-xxl flex-grow-1 container-p-y">
                <div className="card">
                    <div className="card-header d-flex justify-content-between align-items-center">
                        <h3 className="fw-bold mb-0">View Email Temaplate</h3>
                        <div>
                            <Link to='/email_templates' className="btn btn-primary ms-2">
                                <span className="tf-icons bx bx-arrow-back"></span>&nbsp; Back to Email Templates
                            </Link>
                        </div>
                    </div>
                    <div className='p-4'>
                        <form onSubmit={formik.handleSubmit}>
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="mb-3">
                                        <label className="form-label" htmlFor="basic-icon-default-name">Template Name</label>
                                        <div className="input-group input-group-merge">
                                            <span id="basic-icon-default-name" className="input-group-text"><i className="bx bx-user"></i></span>
                                            <input name="name" type="text" className="form-control" id="basic-icon-default-name" placeholder="Template Name" aria-label="Template Name" aria-describedby="basic-icon-default-fullname2" 
                                            value={formik.values.name} 
                                            onChange={formik.handleChange} 
                                            onBlur={formik.handleBlur}
                                            disabled
                                            />
                                        </div>
                                        {formik.touched.name && formik.errors.name && (
                                            <div className="text-danger">{formik.errors.name}</div>
                                        )}
                                    </div>                                
                                </div>
                                <div className='col-md-12'>
                                    <h4 className='mt-3'>Self Assessment</h4>
                                    <div className="mb-3">
                                        <label className="form-label" htmlFor="basic-icon-default-name">Email Subject</label>
                                        <div className="input-group input-group-merge">
                                            <span id="basic-icon-default-name" className="input-group-text"><i className="bx bx-user"></i></span>
                                            <input name="saEmailSubjectForSubject" type="text" className="form-control" id="basic-icon-default-name" placeholder="Email Subject" aria-label="Email Subject" aria-describedby="basic-icon-default-fullname2" 
                                            value={formik.values.saEmailSubjectForSubject} 
                                            onChange={formik.handleChange} 
                                            onBlur={formik.handleBlur}
                                            disabled
                                            />
                                        </div>
                                        {formik.touched.saEmailSubjectForSubject && formik.errors.saEmailSubjectForSubject && (
                                            <div className="text-danger">{formik.errors.saEmailSubjectForSubject}</div>
                                        )}
                                    </div> 
                                    <div className="mb-3">
                                        <label className="form-label" htmlFor="basic-icon-default-name">Email Body</label>
                                        <Editor
                                            apiKey={process.env.REACT_APP_TINYMCE_KEY}
                                            onInit={(_evt, editor) => editorSASubjectRef.current = editor}
                                            disabled
                                            // onEditorChange={(value, editor) => handleEmailBodyChange(value, "saEmailBodyForSubject")}
                                            value={formik.values.saEmailBodyForSubject}
                                            init={{
                                                height: 300,
                                                // menubar: false,
                                                plugins: [
                                                    'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
                                                    'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
                                                    'insertdatetime', 'media', 'table', 'code', 'help', 'wordcount'
                                                ],
                                                toolbar: 'undo redo | blocks | ' +
                                                    'bold italic forecolor | alignleft aligncenter ' +
                                                    'alignright alignjustify | bullist numlist outdent indent | ' +
                                                    'removeformat | help',
                                                content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
                                            }}
                                        />
                                        {formik.touched.saEmailBodyForSubject && formik.errors.saEmailBodyForSubject && (
                                            <div className="text-danger">{formik.errors.saEmailBodyForSubject}</div>
                                        )}
                                    </div>  
                                </div>
                                <div className='col-md-12'>
                                    <h4 className='mt-3'>Reminder For Self Assessment</h4>
                                    <div className="mb-3">
                                        <label className="form-label" htmlFor="basic-icon-default-name">Email Subject</label>
                                        <div className="input-group input-group-merge">
                                            <span id="basic-icon-default-name" className="input-group-text"><i className="bx bx-user"></i></span>
                                            <input name="reminderEmailSubjectForSubject" type="text" className="form-control" id="basic-icon-default-name" placeholder="Email Subject" aria-label="Email Subject" aria-describedby="basic-icon-default-fullname2" 
                                            value={formik.values.reminderEmailSubjectForSubject} 
                                            onChange={formik.handleChange} 
                                            onBlur={formik.handleBlur}
                                            disabled
                                            />
                                        </div>
                                        {formik.touched.reminderEmailSubjectForSubject && formik.errors.reminderEmailSubjectForSubject && (
                                            <div className="text-danger">{formik.errors.reminderEmailSubjectForSubject}</div>
                                        )}
                                    </div> 
                                    <div className="mb-3">
                                        <label className="form-label" htmlFor="basic-icon-default-name">Email Body</label>
                                        <Editor
                                            apiKey={process.env.REACT_APP_TINYMCE_KEY}
                                            onInit={(_evt, editor) => editorReminderSubjectRef.current = editor}
                                            disabled
                                            // onEditorChange={(value, editor) => handleEmailBodyChange(value, "reminderEmailBodyForSubject")}
                                            value={formik.values.reminderEmailBodyForSubject}
                                            init={{
                                                height: 300,
                                                // menubar: false,
                                                plugins: [
                                                    'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
                                                    'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
                                                    'insertdatetime', 'media', 'table', 'code', 'help', 'wordcount'
                                                ],
                                                toolbar: 'undo redo | blocks | ' +
                                                    'bold italic forecolor | alignleft aligncenter ' +
                                                    'alignright alignjustify | bullist numlist outdent indent | ' +
                                                    'removeformat | help',
                                                content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
                                            }}
                                        />
                                        {formik.touched.reminderEmailBodyForSubject && formik.errors.reminderEmailBodyForSubject && (
                                            <div className="text-danger">{formik.errors.reminderEmailBodyForSubject}</div>
                                        )}
                                    </div>
                                </div>
                                <div className='col-md-12'>
                                    <h4 className='mt-3'>Assessment Request For Raters</h4>
                                    <div className="mb-3">
                                        <label className="form-label" htmlFor="basic-icon-default-name">Email Subject</label>
                                        <div className="input-group input-group-merge">
                                            <span id="basic-icon-default-name" className="input-group-text"><i className="bx bx-user"></i></span>
                                            <input name="saEmailSubjectForRater" type="text" className="form-control" id="basic-icon-default-name" placeholder="Email Subject" aria-label="Email Subject" aria-describedby="basic-icon-default-fullname2" 
                                            value={formik.values.saEmailSubjectForRater} 
                                            onChange={formik.handleChange} 
                                            onBlur={formik.handleBlur}
                                            disabled
                                            />
                                        </div>
                                        {formik.touched.saEmailSubjectForRater && formik.errors.saEmailSubjectForRater && (
                                            <div className="text-danger">{formik.errors.saEmailSubjectForRater}</div>
                                        )}
                                    </div> 
                                    <div className="mb-3">
                                        <label className="form-label" htmlFor="basic-icon-default-name">Email Body</label>
                                        <Editor
                                            apiKey={process.env.REACT_APP_TINYMCE_KEY}
                                            onInit={(_evt, editor) => editorSARaterRef.current = editor}
                                            disabled
                                            // onEditorChange={(value, editor) => handleEmailBodyChange(value, "saEmailBodyForRater")}
                                            value={formik.values.saEmailBodyForRater}
                                            init={{
                                                height: 300,
                                                // menubar: false,
                                                plugins: [
                                                    'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
                                                    'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
                                                    'insertdatetime', 'media', 'table', 'code', 'help', 'wordcount'
                                                ],
                                                toolbar: 'undo redo | blocks | ' +
                                                    'bold italic forecolor | alignleft aligncenter ' +
                                                    'alignright alignjustify | bullist numlist outdent indent | ' +
                                                    'removeformat | help',
                                                content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
                                            }}
                                        />
                                        {formik.touched.saEmailBodyForRater && formik.errors.saEmailBodyForRater && (
                                            <div className="text-danger">{formik.errors.saEmailBodyForRater}</div>
                                        )}
                                    </div>
                                </div>
                                <div className='col-md-12'>
                                    <h4 className='mt-3'>Reminder For Raters</h4>
                                    <div className="mb-3">
                                        <label className="form-label" htmlFor="basic-icon-default-name">Email Subject</label>
                                        <div className="input-group input-group-merge">
                                            <span id="basic-icon-default-name" className="input-group-text"><i className="bx bx-user"></i></span>
                                            <input name="reminderEmailSubjectForRater" type="text" className="form-control" id="basic-icon-default-name" placeholder="Email Subject" aria-label="Email Subject" aria-describedby="basic-icon-default-fullname2" 
                                            value={formik.values.reminderEmailSubjectForRater} 
                                            onChange={formik.handleChange} 
                                            onBlur={formik.handleBlur}
                                            disabled
                                            />
                                        </div>
                                        {formik.touched.reminderEmailSubjectForRater && formik.errors.reminderEmailSubjectForRater && (
                                            <div className="text-danger">{formik.errors.reminderEmailSubjectForRater}</div>
                                        )}
                                    </div> 
                                    <div className="mb-3">
                                        <label className="form-label" htmlFor="basic-icon-default-name">Email Body</label>
                                        <Editor
                                            apiKey={process.env.REACT_APP_TINYMCE_KEY}
                                            onInit={(_evt, editor) => editorReminderRaterRef.current = editor}
                                            disabled
                                            // onEditorChange={(value, editor) => handleEmailBodyChange(value, "reminderEmailBodyForRater")}
                                            value={formik.values.reminderEmailBodyForRater}
                                            init={{
                                                height: 300,
                                                // menubar: false,
                                                plugins: [
                                                    'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
                                                    'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
                                                    'insertdatetime', 'media', 'table', 'code', 'help', 'wordcount'
                                                ],
                                                toolbar: 'undo redo | blocks | ' +
                                                    'bold italic forecolor | alignleft aligncenter ' +
                                                    'alignright alignjustify | bullist numlist outdent indent | ' +
                                                    'removeformat | help',
                                                content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
                                            }}
                                        />
                                        {formik.touched.reminderEmailBodyForRater && formik.errors.reminderEmailBodyForRater && (
                                            <div className="text-danger">{formik.errors.reminderEmailBodyForRater}</div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </Layout>
    )
}